import React from 'react';

export interface Item {
  value: string;
  label: string;
}

interface Props {
  items: Item[];
  activeItem: Item['value'];
  onItemSelected?: (item: Item, index: number) => void;
  minWidth?: number;
  disabled?: boolean;
}

const Switch: React.FC<Props> = ({
  items,
  activeItem,
  onItemSelected = () => {},
  minWidth = 128,
  disabled,
}) => {
  const style: React.CSSProperties = { height: '32px' };

  if (minWidth) {
    style.minWidth = `${minWidth}px`;
  }
  return (
    <div className="bg-blue-100 border border-blue-200 rounded-full flex items-center w-full">
      {items.map((item, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={`h-full rounded-full flex items-center justify-center cursor-pointer capitalize w-full ${
            item.value === activeItem
              ? 'bg-blue-900 text-white font-bold'
              : `${disabled && 'cursor-not-allowed'} bg-blue-100 text-gray-700 font-medium`
          }`}
          id={index.toString()}
          onClick={() => !disabled && onItemSelected(item, index)}
          style={style}
        >
          <h4>{item.label}</h4>
        </div>
      ))}
    </div>
  );
};
Switch.displayName = 'Switch';

export default Switch;
